"use strict";

const primitives = require('./primitives');
const semantic = require('./semantic');
const support = require('./support');
const typography = require('./typography');

/**
 * @deprecated используйте актуальную палитру цветов из @platform-ui/themes
 */
module.exports = {
  ...primitives,
  ...semantic,
  ...support,
  ...typography
};